'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// ./~/@social-solutions/ssg-forms/~/react/react.js
// module id = 721
// module chunks = 0